<app-question-card>
  <p question>Let’s verify owner information.</p>

  <form input-options #loginForm="ngForm">
    <!--    <div class="box-c mb-20" *ngIf="journeyType === FelloOfferJourneyType.IO; else LwfBox">-->
    <!--      <p>Please provide your phone number so that we can reach out to you once your offer is ready.</p>-->
    <!--    </div>-->

    <!--    <ng-template #LwfBox>-->
    <!--      <div class="box-c mb-20">-->
    <!--        <p>-->
    <!--          We need your phone number so that your matched Fello partner agent can reach out to you for discussing the next steps for selling-->
    <!--          your home.-->
    <!--        </p>-->
    <!--      </div>-->
    <!--    </ng-template>-->
    <div class="flex-box">
      <div class="form-field mb-3">
        <label class="mb-1 d-block">First Name</label>
        <input
          type="text"
          placeholder="First Name"
          required
          [(ngModel)]="firstName"
          [minlength]="2"
          [maxLength]="64"
          #firstNameInputField="ngModel"
          (keyup.enter)="(firstName.length > 1) && lastNameInput.focus()"
          name="firstName"
        />
      </div>
      <div class="form-field mb-3 ml-3">
        <label class="mb-1 d-block">Last Name</label>
        <input
          type="text"
          placeholder="Last Name"
          [(ngModel)]="lastName"
          [maxLength]="64"
          [minlength]="1"
          #lastNameInputField="ngModel"
          required
          #lastNameInput
          (keyup.enter)="(lastName.length > 0) && loginForm?.valid && next()"
          name="lastName"
        />
      </div>
    </div>

    <div class="mb-3 form-field">
      <label class="d-block"> Phone </label>

      <input
        type="tel"
        placeholder="Phone number"
        name="phone"
        libFormatPhone
        [pattern]="phoneNumberPattern"
        (keyup.enter)="loginForm?.valid"
        [(ngModel)]="userPhone"
        required
      />
    </div>

    <div class="mb-3 form-field">
      <label class="d-block"> Email </label>
      <input
        type="email"
        placeholder="Email address"
        name="email"
        required
        [(ngModel)]="userEmail"
        libEmail
        (keyup.enter)="loginForm.valid && next()"
      />
    </div>
  </form>

  <p class="chat-answer" answer>
    {{firstName}} {{lastName}}<br />
    {{userPhone}}<br />
    {{userEmail}}
  </p>

  <button class="w-100" footer (click)="next()" [disabled]="loginForm?.invalid">Continue</button>
</app-question-card>
